

































import { defineComponent, PropType } from '@nuxtjs/composition-api'

const MIN_PRICE = 500 // 歴史的な理由（アプリの都合）により、予算の「〇〇円以内」はprice_min=nullではなく500で登録されている

const dRequestPrice = defineComponent({
  name: 'DRequestPrice',
  props: {
    priceMin: {
      type: Number as PropType<number>,
      default: 0
    },
    priceMax: {
      type: Number as PropType<number>,
      default: 0
    },
    addBr: {
      type: Boolean as PropType<boolean>,
      default: false
    }
  },
  setup() {
    return { MIN_PRICE }
  }
})
export default dRequestPrice
